import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useHp } from "../hp/useHp";
import { aturChat } from "./chatState";
import { KonteksChat, jalurChat } from "./chatKonteks";
import LembarMasukChat from "./LembarMasukChat";
import PanelChat from "./PanelChat";
import "./chat.css";

// PR chat pembeli tahap 1: satu bendera dari server (GET /api/chat/status; 404 = mati). Tampilan tidak menebak sendiri: selama belum aktif, WhatsApp tetap seperti sekarang.
const tokenSesi = () => { try { return localStorage.getItem("hs_token") || ""; } catch { return ""; } };
const HALAMAN_TANPA_TOMBOL = /^\/(checkout|invoice|login|register|masuk-google|atur-sandi|admin|chat)(\/|$)/;

export function ChatProvider({ children }) {
  const { user, ready } = useAuth();
  const hp = useHp();
  const nav = useNavigate();
  const lokasi = useLocation();
  const [st, setSt] = useState({ aktif: false, masuk: false, teks_jam: "", belum_dibaca: 0 });
  const [lembar, setLembar] = useState(null);   // { konteks } = belum masuk
  const [panel, setPanel] = useState(null);     // { konteks } = panel komputer terbuka

  // Jawaban milik sesi lama diabaikan: ikon & lencana akun sebelumnya tidak boleh tampil pada sesi baru
  const generasi = useRef(0);
  const muat = useCallback(() => { const g = generasi.current, tok = tokenSesi(); const basi = () => g !== generasi.current || tok !== tokenSesi(); return api.get("/api/chat/status")
    .then(({ data }) => { if (basi()) return; setSt({ aktif: !!data.aktif, masuk: !!data.masuk, teks_jam: data.teks_jam || "", belum_dibaca: Number(data.belum_dibaca) || 0 }); })
    // 404 = chat mati. Gangguan jaringan sesaat tidak mematikan chat di layar: keadaan terakhir dipertahankan.
    .catch((e) => { if (!basi() && e && e.response && e.response.status === 404) setSt({ aktif: false, masuk: false, teks_jam: "", belum_dibaca: 0 }); }); }, []);

  useEffect(() => {
    generasi.current += 1;
    setSt({ aktif: false, masuk: false, teks_jam: "", belum_dibaca: 0 });
    if (ready) muat();
  }, [ready, user && user.id, muat]);   // eslint-disable-line react-hooks/exhaustive-deps
  // Akun berganti lewat tab lain: AuthContext tab ini tidak tahu, jadi status dikosongkan dan dibaca ulang dengan token baru
  useEffect(() => {
    const pantau = (e) => {
      if (e.key !== null && e.key !== "hs_token") return;
      generasi.current += 1;
      setSt({ aktif: false, masuk: false, teks_jam: "", belum_dibaca: 0 });
      setPanel(null); setLembar(null);
      muat();
    };
    window.addEventListener("storage", pantau);
    return () => window.removeEventListener("storage", pantau);
  }, [muat]);
  // Lencana belum dibaca: tiap 60 detik selama tab terlihat
  useEffect(() => {
    if (!st.aktif || !st.masuk) return undefined;
    const t = setInterval(() => { if (!document.hidden) muat(); }, 60000);
    return () => clearInterval(t);
  }, [st.aktif, st.masuk, muat]);

  const buka = useCallback((konteks = null) => {
    if (!user) { setLembar({ konteks }); return; }
    if (hp) { nav(jalurChat(konteks), { state: { dariChat: `${lokasi.pathname}${lokasi.search}` } }); return; }
    setPanel((lama) => (lama && konteks === null ? lama : { konteks }));   // panel sudah terbuka: ikon kepala tidak mengganti konteks atau membuka panel kedua
  }, [user, hp, nav, lokasi.pathname, lokasi.search]);

  // Ditulis saat render, sebelum komponen pembeli yang membaca useChat() merender teks "melalui chat"
  aturChat({ aktif: st.aktif, buka });
  // Sesi berganti di tab ini (keluar, masuk akun lain): panel & lembar milik sesi lama ditutup
  const uid = user ? user.id : null;
  useEffect(() => { setPanel(null); setLembar(null); }, [uid]);
  const nilai = useMemo(() => ({ ...st, buka, muatStatus: muat }), [st, buka, muat]);
  const tampilTombol = st.aktif && !hp && !HALAMAN_TANPA_TOMBOL.test(lokasi.pathname);

  return (
    <KonteksChat.Provider value={nilai}>
      {children}
      {lembar && <LembarMasukChat konteks={lembar.konteks} onTutup={() => setLembar(null)} />}
      {st.aktif && !hp && panel && <PanelChat key={uid || "tamu"} konteks={panel.konteks} onKecil={() => setPanel(null)} />}
      {tampilTombol && (
        <button type="button" className="cht-melayang" aria-label="Buka chat" data-testid="chat-melayang" aria-expanded={!!panel}
          onClick={() => (panel ? setPanel(null) : buka(null))}>
          <GelembungKecil />Chat
          {st.belum_dibaca > 0 && <span className="cht-lencana" data-testid="chat-lencana">{st.belum_dibaca}</span>}
        </button>
      )}
    </KonteksChat.Provider>
  );
}
function GelembungKecil() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" /></svg>;
}
